export const wrapStepError = (err, step, phase) => {
    const wrapped = new Error('step "' + step.id + '" (' + step.type + ', ' + phase + '): ' + (err && err.message ? err.message : String(err)));
    wrapped.cause = err;
    return wrapped;
};

export const describeError = (err) => err && err.message ? err.message : String(err);
